import {
	formatCurrencyForDisplay,
	useIntlConfig,
} from '@monthio/react-components'

export const useFormattedAmount = (
	amount: number,
	currency: string,
): string => {
	const intlConfig = useIntlConfig({
		currency,
		showCurrency: true,
	})
	return formatCurrencyForDisplay({
		value: amount.toFixed(0),
		intlConfig,
	})
}
